import { Component, Input, OnInit, OnDestroy } from '@angular/core';

import { CommonModule } from '@angular/common';
import { HmfProgressRingComponent } from '@dsg-tech/homefield-angular';
import { LoyaltyBalance } from '@scorecard/data-access';
import { Store } from '@shared/data-access/services';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'common-points-progress-ring',
    templateUrl: './points-progress-ring.component.html',
    imports: [CommonModule, HmfProgressRingComponent]
})
export class PointsProgressRingComponent implements OnInit, OnDestroy {
	currentPointBalance = 0;
	pointsTarget = 300;
	private ngUnsubscribe: Subject<void> = new Subject();

	@Input() size = 'large';

	constructor(private store: Store) {}

	ngOnInit() {
		this.store.select<LoyaltyBalance>('LOYALTY_BALANCE', true)
			.pipe(takeUntil(this.ngUnsubscribe)).subscribe((loyaltyBalance) => {
				this.currentPointBalance = loyaltyBalance.currentPointBalance;
			});
	}

	ngOnDestroy(): void {
		this.ngUnsubscribe.next();
		this.ngUnsubscribe.complete();
	}
}
